<template>
  <div class="page-operation">

    <div class="has-text-centered mb-6" v-if="init.name || init.subname">
      <h1 v-if="init.name" class="title is-3">{{init.name}}</h1>
      <h2 v-if="init.subname" class="subtitle is-5">{{init.subname}}</h2>
    </div>

    <div class="tabs is-centered is-boxed noPrint">
      <ul>
        <li :class="{'is-active': tabActive === 'info'}" @click="tabActive = 'info'">
          <a>
            <span class="icon is-small"><font-awesome-icon icon="file-lines" /></span>
            <span>Informazioni</span>
          </a>
        </li>
      </ul>
    </div>

    <transition name="fade" mode="out-in">
      <div v-show="tabActive === 'info'">

        <form class="columns is-multiline" @submit.prevent="operation._id ? updateOperation() : saveOperation()">
          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputSelect
              name="Proprietario"
              v-model="operation.client"
              :options="clients"
              :loading="waitClients"
              :disabled="disableClient || waitRecord || !$store.getters.amAdmin"
              id="_id"
              track-by="_id"
              :custom-label="$clientName"
              @select="changeClient"
            >
              <a class="button is-warning" :href="operation.client ? '/clienti/'+operation.client._id : 'javascript:void(0)'"><font-awesome-icon icon="user" class="m-0" /></a>
            </InputSelect>

            <ClientInfo :client="operation.client" :showAddress="true" />
          </div>

          <div class="column is-12 p-0"></div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputSelect
              name="Occupante"
              v-model="operation.occupant"
              :options="clients"
              :loading="waitClients"
              :disabled="disableOccupant || waitRecord || !$store.getters.amAdmin"
              id="_id"
              track-by="_id"
              :custom-label="$clientName"
              @select="changeOccupant"
            >
              <a class="button is-warning" :href="operation.occupant ? '/clienti/'+operation.occupant._id : 'javascript:void(0)'"><font-awesome-icon icon="user" class="m-0" /></a>
            </InputSelect>

            <ClientInfo :client="operation.occupant" />
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputSelect
              name="Luogo"
              v-model="operation.place"
              :options="places"
              :loading="waitPlaces"
              :disabled="waitRecord || !operation.client || !$store.getters.amAdmin"
              id="_id"
              track-by="_id"
              :custom-label="$placeName"
              @select="changePlace"
            >
              <a class="button is-warning" :href="operation.place ? '/luoghi/'+operation.place._id : 'javascript:void(0)'"><font-awesome-icon icon="building" class="m-0" /></a>
            </InputSelect>
          </div>

          <div class="column is-12 p-0"></div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputSelect
              name="Impianto"
              v-model="operation.implant"
              :options="implants"
              :loading="waitImplants"
              :disabled="waitRecord || !operation.place || !$store.getters.amAdmin"
              id="_id"
              track-by="_id"
              :custom-label="$implantName"
              :allowEmpty="true"
              @select="changeImplant"
            >
              <a class="button is-warning" :href="operation.implant ? '/impianti/'+operation.implant._id : 'javascript:void(0)'"><font-awesome-icon icon="temperature-arrow-up" class="m-0" /></a>
            </InputSelect>
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputSelect
              name="Codice"
              v-model="operation.implantCode"
              :options="operation.implant?.codes"
              :loading="waitImplants"
              :disabled="waitRecord || !operation.implant || !$store.getters.amAdmin"
              :allowEmpty="true"
              @select="changeImplantCode"
            />
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputSelect
              name="Generatore"
              v-model="operation.implantGenerators"
              :options="generators"
              :loading="waitImplants"
              :disabled="waitRecord || !operation.implant || !$store.getters.amAdmin"
              id="_id"
              track-by="_id"
              :custom-label="$generatorNameReg"
              :allowEmpty="true"
              :multiple="true"
            />
            <div class="has-text-grey" v-if="operation.implantGenerators && getInstallers(operation.implantGenerators)"><small>{{getInstallers(operation.implantGenerators)}}</small></div>
          </div>

          <div class="column is-12 p-0"></div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <div class="field">
              <label class="label">Data ricezione</label>
              <div class="control">
                <input class="input" type="date" placeholder="Data ricezione" v-model="operation.reception_date" :readonly="!$store.getters.amAdmin" />
              </div>
            </div>
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputSelect
              name="Tipologia"
              v-model="operation.type"
              :options="$store.state.operation_types.map(({ name }) => name)"
              :disabled="!$store.getters.amAdmin"
              @select="preselectRevision"
            />
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="isProgressive">
            <InputText name="Progressivo" v-model="operation.progressive">
              <button @click="getProgressive()" class="button is-light is-primary" type="button">Calcola</button>
            </InputText>
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="isMaintenance">
            <InputSelect
              v-if="operation.implant && operation.implant.revisions && operation.implant.revisions.length > 0"
              name="Manutenzione"
              v-model="operation.revision"
              :options="operation.implant.revisions"
              id="_id"
              track-by="_id"
              label="type"
              :disabled="!$store.getters.amAdmin"
            />
            <div class="has-text-centered has-text-grey" v-if="!operation.implant || !operation.implant.revisions || operation.implant.revisions.length === 0"><i>Nessuna manutenzione</i></div>
          </div>

          <div class="column is-12" v-if="isMaintenance && operation.revision && operation.implant">
            <hr />
          </div>

          <div class="column is-12" v-if="isMaintenance && operation.revision && operation.implant">
            <Revisions ref="revisions" :revisions="operation.implant.revisions.filter(rev => rev._id === operation.revision._id)" :operation="operation" :noEdit="true" @addLog="endCloseAppointment()" :codes="operation.implant.codes" :implant="operation.implant" />

            <div class="has-text-centered has-text-grey" v-if="!operation.implant.revisions || operation.implant.revisions.length === 0"><i>Nessuna manutenzione</i></div>
          </div>

          <div class="column is-12">
            <hr />
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputSelect
              name="Collaboratore"
              v-model="operation.operators"
              :options="$store.getters.operators"
              :disabled="waitRecord || !$store.getters.amAdmin"
              id="_id"
              track-by="_id"
              :custom-label="$fullname"
              :multiple="true"
            />
            <div v-if="operation.client && operation.client.favorite_collaborators && operation.client.favorite_collaborators.length" class="is-flex mt-2">
              <span class="has-text-danger">Collaboratori preferiti:</span>
              <span class="tags ml-2">
                <span class="tag is-info" v-for="(coll, index) in operation.client.favorite_collaborators" :key="index">
                  {{$fullname(coll)}}
                </span>
              </span>
            </div>
          </div>

          <div class="column is-12"></div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <div class="field">
              <label class="label">Data appuntamento</label>
              <div class="control">
                <input class="input" type="date" placeholder="Data appuntamento" v-model="operation.appointment_date" :required="true" :readonly="!$store.getters.amAdmin" />
              </div>
            </div>
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <div class="field">
              <label class="label">Orario inizio</label>
              <div class="control">
                <input class="input" type="time" placeholder="Orario appuntamento" v-model="operation.appointment_start" :required="true" :readonly="!$store.getters.amAdmin" />
              </div>
            </div>
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <div class="field">
              <label class="label">Orario fine</label>
              <div class="control">
                <input class="input" type="time" placeholder="Orario appuntamento" v-model="operation.appointment_end" :required="true" :readonly="!$store.getters.amAdmin" />
              </div>
            </div>
          </div>

          <div class="column is-12"></div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputSelect
              name="Stato"
              v-model="operation.status"
              :options="['Annullato', 'Da completare']"
            />
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop is-flex">
            <div class="field">
              <label class="label" for="special">&nbsp;</label>
              <div class="control is-flex">
                <input type="checkbox" id="special" v-model="operation.special">
                <label for="special" class="label-special pink"></label>
              </div>
            </div>

            <div class="field ml-3">
              <label class="label" for="special2">&nbsp;</label>
              <div class="control is-flex">
                <input type="checkbox" id="special2" v-model="operation.special2">
                <label for="special2" class="label-special red"></label>
              </div>
            </div>
          </div>

          <div :class="['column is-12-mobile is-6-tablet is-4-desktop', { 'noPrint': !activeSubscription && !mostRecentExpiredSubscription }]">
            <div class="box" style="padding: 0.5rem;">
              <div v-if="operation.implant">
                <div><strong>Abbonamento impianto:</strong></div>
                <div v-if="activeSubscription" class="mt-1">
                  <small>
                    <span class="tag is-small is-success">
                      Valido
                    </span>
                    <b class="ml-2">{{ new Date(activeSubscription.start).toDisplay() }}</b> — <b>{{ new Date(activeSubscription.end).toDisplay() }}</b>
                  </small>
                </div>
                <div v-else-if="mostRecentExpiredSubscription" class="mt-1">
                  <small>
                    <span class="tag is-samll is-danger">
                      Scaduto
                    </span>
                    <b class="ml-2">{{ new Date(mostRecentExpiredSubscription.start).toDisplay() }}</b> — <b>{{ new Date(mostRecentExpiredSubscription.end).toDisplay() }}</b>
                  </small>
                </div>
                <div v-else class="mt-1"><small class="has-text-grey">Nessun abbonamento attivo</small></div>
                <div class="mt-2">
                  <button type="button" class="button is-small is-primary" :disabled="activatingSubscription || activeSubscription || !isSubscriptionCityEnabled" @click="activateSubscription()">Attiva abbonamento</button>
                  <button type="button" class="button is-small is-warning ml-2" :disabled="!editableSubscription || savingSubscriptionEdit" @click="openSubscriptionEditModal(editableSubscription)">Modifica date</button>
                </div>
                <div class="mt-1" v-if="operation.implant && !isSubscriptionCityEnabled">
                  <small class="has-text-danger">Città non abilitata per nuovi abbonamenti</small>
                </div>
              </div>
              <div v-else>
                <small class="has-text-grey">Seleziona un impianto per gestire abbonamenti</small>
              </div>
            </div>
          </div>

          <!--<div class="column is-12" v-if="operation.linked_operation_next">
            <label class="label">Appuntamento successivo</label>
              <div class="control is-flex">
                <router-link v-if="operation.linked_operation_next" :to="'/appuntamenti/' + operation.linked_operation_next" class="button is-success has-tooltip-arrow has-tooltip-multiline" data-tooltip="Appuntamento successivo">
                  <font-awesome-icon icon="file-lines" class="m-0" />
                </router-link>
              </div>
          </div>

          <div class="column is-12" v-if="operation.linked_operation_prev">
            <label class="label">Appuntamento precedente</label>
              <div class="control is-flex">
                <router-link v-if="operation.linked_operation_prev" :to="'/appuntamenti/' + operation.linked_operation_prev" class="button is-success has-tooltip-arrow has-tooltip-multiline" data-tooltip="Appuntamento precedente">
                  <font-awesome-icon icon="file-lines" class="m-0" />
                </router-link>
              </div>
          </div>-->

          <div class="column is-12"></div>

          <div :class="['column is-12-mobile is-9-tablet', { 'noPrint': operation.linked?.length === 0 }]">
            <div class="field">
              <div class="is-flex is-align-items-center is-justify-content-space-between">
                <label class="label">Materiale utilizzato</label>
                <div class="has-text-right">
                  <button class="button is-success" type="button" @click="openModalAddProduct = true"><font-awesome-icon icon="plus" />Aggiungi</button>
                </div>
              </div>
              <div class="control">
                <div class="table-wrapper has-mobile-cards">
                  <table class="table is-fullwidth is-striped is-hoverable">
                    <thead>
                    <tr>
                      <th>Produttore</th>
                      <th>Codice</th>
                      <th>Descrizione</th>
                      <th>Unità</th>
                      <th>Iva</th>
                      <th style="width: 180px;">Prezzo listino</th>
                      <th style="width: 180px;">Prezzo vendita</th>
                      <th style="width: 80px;">Quantità</th>
                      <th style="width: 120px;">Totale ivato</th>
                      <th style="width: 50px;">Ricevuto</th>
                      <th style="width: 50px;">Ordine</th>
                      <th style="width: 100px;"></th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(link, index) in operation.linked" :key="index">
                        <td data-label="Produttore">
                          {{ link.product.brand }}
                        </td>
                        <td data-label="Codice">
                          {{ link.product.code }}
                        </td>
                        <td data-label="Descrizione">
                          {{ link.product.name }}
                        </td>
                        <td data-label="Unità">
                          {{ link.product.unit }}
                        </td>
                        <td data-label="Iva">
                          <InputSelect
                            :name="''"
                            v-model="link.vat"
                            :options="vatOptions"
                            :disabled="!$store.getters.amAdmin"
                          />
                        </td>
                        <td data-label="Prezzo listino">
                          <input class="input" type="text" placeholder="Prezzo listino" v-model="link.product.price" disabled />
                        </td>
                        <td data-label="Prezzo vendita">
                          <div>€ {{link.customPrice || link.product.lastSalePrice || link.product.price || '0.00'}}</div>
                        </td>
                        <td data-label="Quantità">
                          <input class="input" type="text" placeholder="Quantità" v-model="link.quantity" disabled />
                        </td>
                        <td data-label="Totale ivato">
                          <div style="white-space: nowrap;">€ {{calcLinkTotal(link)}}</div>
                        </td>
                        <td data-label="Ricevuto">
                          <label class="checkbox">
                            <input type="checkbox" v-model="link.product.isReceived" disabled>
                          </label>
                        </td>
                        <td data-label="Ordine">
                          <router-link class="button is-primary is-small" :to="'/ordini/' + link.order"><font-awesome-icon icon="eye" />Visualizza</router-link>
                        </td>
                        <td class="is-actions-cell">
                          <button class="button is-info is-small" type="button" @click="openEditPriceModal(link)" title="Modifica prezzo">
                            <font-awesome-icon icon="pen" /> Prezzo
                          </button>
                        </td>
                      </tr>
                      <tr v-if="operation.linked?.length === 0">
                        <td colspan="100" class="has-text-centered has-text-grey">
                          <i>Nessun risultato</i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-12"></div>

          <div class="column is-12 noPrint" v-show="isDocumentation">
            <div class="field">
              <label class="label" for="receipt">Documentazione mancante</label>
              <div class="control">
                <input type="checkbox" id="receipt" v-model="operation.missing_documentation">
              </div>
            </div>
          </div>

          <div class="column is-12 noPrint">
            <div class="field">
              <label class="label" for="confirmed">Appuntamento confermato</label>
              <div class="control">
                <input type="checkbox" id="confirmed" v-model="operation.confirmed">
              </div>
            </div>
          </div>

          <div class="column is-12-mobile is-1-tablet">
            <div class="field">
              <label class="label" for="paid">Pagato</label>
              <div class="control">
                <input type="checkbox" id="paid" v-model="operation.paid">
              </div>
            </div>
          </div>
          <div class="column is-12-mobile is-1-tablet">
            <div class="field">
              <label class="label" for="no_due">Non deve nulla</label>
              <div class="control">
                <input type="checkbox" id="no_due" v-model="operation.no_due">
              </div>
            </div>
          </div>
          <div class="column is-12-mobile is-1-tablet">
            <div class="field">
              <label class="label" for="receipt">Scontrino</label>
              <div class="control">
                <input type="checkbox" id="receipt" v-model="operation.receipt" :disabled="operation.to_invoice">
              </div>
            </div>
          </div>
          <div class="column is-12-mobile is-1-tablet">
            <div class="field">
              <label class="label" for="to_invoice">Da fatturare</label>
              <div class="control">
                <input type="checkbox" id="to_invoice" v-model="operation.to_invoice" :disabled="operation.receipt">
              </div>
            </div>
          </div>
          <div class="column is-12-mobile is-1-tablet" v-show="operation.to_invoice">
            <div class="field">
              <label class="label" for="invoiced">Fatturato</label>
              <div class="control">
                <input type="checkbox" id="invoiced" v-model="operation.invoiced">
              </div>
            </div>
          </div>
          <div class="column is-12-mobile is-2-tablet" v-show="operation.to_invoice && operation.invoiced">
            <InputText name="Numero Fattura" v-model="operation.invoice_number" />
          </div>
          <div class="column is-12-mobile is-2-tablet" v-show="operation.receipt">
            <InputSelect
              name="Metodo pagamento"
              v-model="operation.payment_method"
              :options="['Contanti', 'Pos', 'Bonifico']"
            />
          </div>
          <!--<div class="column is-12-mobile is-1-tablet" v-show="operation.receiptType === 'Fattura'">
            <div class="field">
              <label class="label" for="invoiced">Fatturato</label>
              <div class="control">
                <input type="checkbox" id="invoiced" v-model="operation.invoiced" :disabled="!$store.getters.amAdmin">
              </div>
            </div>
          </div>
          <div class="column is-12-mobile is-1-tablet">
            <div class="field">
              <label class="label" for="paid">Pagato</label>
              <div class="control">
                <input type="checkbox" id="paid" v-model="operation.paid">
              </div>
            </div>
          </div>-->
          <div class="column is-12-mobile is-1-tablet">
            <div class="field">
              <label class="label" for="to_fgas">Fare Fgas</label>
              <div class="control">
                <input type="checkbox" id="to_fgas" v-model="operation.to_fgas" :disabled="!$store.getters.amAdmin">
              </div>
            </div>
          </div>
          <div class="column is-12-mobile is-1-tablet" v-show="operation.to_fgas">
            <div class="field">
              <label class="label" for="fgas">Fgas</label>
              <div class="control">
                <input type="checkbox" id="fgas" v-model="operation.fgas" :disabled="!$store.getters.amAdmin">
              </div>
            </div>
          </div>
          <div class="column is-12-mobile is-1-tablet">
            <div class="field">
              <label class="label" for="to_curmit">Fare Curmit</label>
              <div class="control">
                <input type="checkbox" id="to_curmit" v-model="operation.to_curmit" :disabled="!$store.getters.amAdmin">
              </div>
            </div>
          </div>
          <div class="column is-12-mobile is-1-tablet" v-show="operation.to_curmit">
            <div class="field">
              <label class="label" for="curmit">Curmit</label>
              <div class="control">
                <input type="checkbox" id="curmit" v-model="operation.curmit" :disabled="!$store.getters.amAdmin">
              </div>
            </div>
          </div>
          <div class="column is-12-mobile is-1-tablet">
            <div class="field">
              <label class="label" for="exception">Eccezione</label>
              <div class="control">
                <input type="checkbox" id="exception" v-model="operation.exception" :disabled="!$store.getters.amAdmin">
              </div>
            </div>
          </div>
          <div class="column is-12-mobile is-1-tablet">
            <div class="field">
              <label class="label" for="controlled">Controllato</label>
              <div class="control">
                <input type="checkbox" id="controlled" v-model="operation.controlled" :disabled="!$store.getters.amAdmin">
              </div>
            </div>
          </div>

          <div class="column is-12"></div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputTextarea name="Motivo intervento" v-model="operation.notes_office" />
          </div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <InputTextarea name="Note tecnico" v-model="operation.notes" />
          </div>

          <div class="column is-12 py-0"></div>

          <div class="column is-12-mobile is-6-tablet is-4-desktop">
            <div class="card mb-3" v-for="(archived_note, index) in operation.archived_notes?.toReversed()" :key="index">
              <div class="card-content">
                <div class="content">
                  <div><span class="is-size-6 has-text-weight-bold">Data: </span>{{ (new Date(archived_note.date)).toDisplay() }}</div>
                  <InputTextarea name="Motivo intervento" :modelValue="archived_note.notes_office" disabled />
                  <InputTextarea name="Note tecnico" :modelValue="archived_note.notes" disabled />
                </div>
              </div>
            </div>
          </div>

          <div class="column is-full noPrint">
            <div class="field is-grouped is-grouped-centered buttons">
              <button @click="goBack()" class="button is-light" type="button"><font-awesome-icon icon="times" />Chiudi</button>
              <button class="button is-primary" :class="[{'is-loading': disabledSave}]" type='submit' :disabled="disabledSave"><font-awesome-icon icon="save" />Salva</button>
              <button v-if="operation._id" class="button is-success" :class="[{'is-loading': disabledSave}]" type='button' :disabled="disabledSave || operation.status == 'Concluso'" @click="startCloseAppointment()"><font-awesome-icon icon="lock" />Concludi</button>
              <button v-if="operation._id" class="button is-info" :class="[{'is-loading': creatingCall}]" type='button' :disabled="disabledSave || creatingCall" @click="createNewCall()"><font-awesome-icon icon="phone" />Nuova chiamata</button>
            </div>
          </div>
        </form>

      </div>
    </transition>

    <Modal :title="'Aggiungi prodotto'" :openModal="openModalAddProduct" @close="openModalAddProduct = false" @success="findOrder" :disabled="!addProductSelected" saveLabel="Seleziona ordine" style="width: 95%;">
      <div class="columns is-multiline">
        <div class="column is-12">
          <ProductList :isSelection="true" @selected="value => selectedProduct(value)" />
        </div>
      </div>
    </Modal>

    <Modal :title="'Seleziona ordine'" :openModal="openModalSelectOrder" @close="openModalSelectOrder = false" @success="addOrder" :hasDisclaimer="true" style="width: 60%;">
      <div class="columns is-multiline">
        <div class="column is-12">
          <div class="table-wrapper has-mobile-cards">
            <table class="table is-fullwidth is-striped is-hoverable">
              <thead>
                <tr>
                  <th style="width: 24px;"></th>
                  <th>Data</th>
                  <th>Utente</th>
                  <th>Fornitore</th>
                  <th>Ordinato</th>
                  <th>Prodotti</th>
                  <th>Note</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(order, index) in orders" :key="index">
                  <td>
                    <label class="radio">
                      <input type="radio" :value="order" v-model="selectedOrder">
                    </label>
                  </td>
                  <td data-label="Data">
                    <div v-if="order.date">{{new Date(order.date).toDisplay()}}</div>
                  </td>
                  <td data-label="Utente">
                    {{$fullname(order.user)}}
                  </td>
                  <td data-label="Fornitore">
                    {{order.supplier}}
                  </td>
                  <td data-label="Ordinato">
                    <div v-if="order.isRequested" class="has-text-success has-text-centered">
                      <font-awesome-icon icon="fa-regular fa-circle-check" />
                    </div>
                    <div v-else class="has-text-danger has-text-centered">
                      <font-awesome-icon icon="fa-regular fa-circle-xmark" />
                    </div>
                  </td>
                  <td data-label="Prodotti">
                    <div v-for="(product, index) in order.products" :key="index">
                      {{ product.quantity }}x {{ product.brand }} {{ product.code }} {{ product.name }}
                    </div>
                  </td>
                  <td data-label="Note">
                    {{order.notes}}
                  </td>
                </tr>
                <tr v-if="orders.length === 0">
                  <td colspan="100" class="has-text-centered has-text-grey">
                    <i>Nessun risultato</i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Modal>

    <Modal :title="'Modifica prezzo prodotto'" :openModal="editPriceModal" @close="editPriceModal = false" @success="saveCustomPrice()">
      <div class="columns is-multiline">
        <div class="column is-12">
          <div class="notification is-info is-light">
            <p><strong>Prezzo di listino:</strong> € {{editPriceLink?.product?.lastSalePrice || editPriceLink?.product?.price || '0.00'}}</p>
            <p class="mt-2"><strong>Prodotto:</strong> {{editPriceLink?.product?.brand}} {{editPriceLink?.product?.code}} {{editPriceLink?.product?.name}}</p>
          </div>
        </div>
        <div class="column is-12">
          <InputText name="Prezzo personalizzato" v-model="editPriceValue" type="number" step="0.01" required />
        </div>
        <div class="column is-12" v-if="editPriceValue">
          <div class="notification is-success is-light">
            <p><strong>Totale ivato:</strong> € {{calcEditedLinkTotalIvato()}}</p>
          </div>
        </div>
      </div>
    </Modal>

    <Modal :title="'Modifica date abbonamento'" :openModal="openModalSubscriptionEdit" @close="openModalSubscriptionEdit = false" @success="saveSubscriptionDatesFromOperation" :loading="savingSubscriptionEdit" :allowOverflow="true">
      <div class="columns is-multiline">
        <div class="column is-12">
          <div class="field">
            <label class="label">Data inizio</label>
            <InputDate v-model="subscriptionEditForm.start" placeholder="Data inizio" />
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label">Data fine</label>
            <InputDate v-model="subscriptionEditForm.end" placeholder="Data fine" />
          </div>
        </div>
      </div>
    </Modal>

  </div>
</template>
  
<script>
import ProductList from './ProductList'

import utils from '../utils'
import cloneDeep from 'lodash.clonedeep'

export default {
  components: {
    ProductList
  },

  data() {
    return {
      operation: {
        reception_date: (new Date()).toDateInputValue(),
        implantGenerators: [],
        paid: false,
        no_due: false,
        payment_method: '',
        invoice_number: ''
      },
      clients: [],
      places: [],
      implants: [],

      tabActive: 'info',

      init: {
        name: false,
        subname: false
      },

      waitRecord: true,
      waitClients: true,
      waitPlaces: false,
      waitImplants: false,
      activatingSubscription: false,
      savingSubscriptionEdit: false,

      openModalSubscriptionEdit: false,
      subscriptionEditForm: {
        start: '',
        end: ''
      },
      selectedSubscription: null,

      disabledSave: false,

      disableClient: false,
      disableOccupant: false,

      originalOperation: {},

      openModalAddProduct: false,
      addProductSelected: false,

      openModalSelectOrder: false,
      orders: [],
      selectedOrder: null,

      creatingCall: false,

      editPriceModal: false,
      editPriceLink: null,
      editPriceValue: '',

      vatOptions: ['10', '22']
    }
  },

  computed: {
    editableSubscription() {
      return this.activeSubscription || this.mostRecentExpiredSubscription || null
    },

    enabledSubscriptionCityNames() {
      return (this.$store.state.subscription_enabled_cities || [])
        .map(row => this.normalizeSubscriptionCity(row?.name))
        .filter(Boolean)
    },

    subscriptionPlaceCity() {
      const city = this.operation?.place?.city || this.operation?.implant?.place_occupant?.city || ''
      return this.normalizeSubscriptionCity(city)
    },

    isSubscriptionCityEnabled() {
      if (!this.operation?.implant) {
        return false
      }

      const city = this.subscriptionPlaceCity
      if (!city) {
        return false
      }

      return this.enabledSubscriptionCityNames.includes(city)
    },

    activeSubscription() {
      const imp = this.operation.implant
      if (!imp || !imp.subscriptions) return null
      const today = new Date(); today.setHours(0,0,0,0)
      return imp.subscriptions.find(s => {
        if (!s.end) return false
        const ed = new Date(s.end); ed.setHours(0,0,0,0)
        return ed >= today
      }) || null
    },
    mostRecentExpiredSubscription() {
      const imp = this.operation.implant
      if (!imp || !imp.subscriptions) return null
      const today = new Date(); today.setHours(0,0,0,0)
      const expired = imp.subscriptions.filter(s => {
        if (!s.end) return false
        const ed = new Date(s.end); ed.setHours(0,0,0,0)
        return ed < today
      })
      if (!expired.length) return null
      expired.sort((a, b) => new Date(b.end) - new Date(a.end))
      return expired[0]
    },
    
    isMaintenance() {
      if (this.operation.type) {
        const found = this.$store.state.operation_types.find(ot => ot.name === this.operation.type && ot.maintenance)

        return found
      }

      return false
    },

    isDocumentation() {
      if (this.operation.type) {
        const found = this.$store.state.operation_types.find(ot => ot.name === this.operation.type && ot.documentation)

        return found
      }

      return false
    },

    isRequiredNotes() {
      if (this.operation.type) {
        const found = this.$store.state.operation_types.find(ot => ot.name === this.operation.type && ot.notes)

        return found
      }

      return false
    },

    isProgressive() {
      if (this.operation.type) {
        const found = this.$store.state.operation_types.find(ot => ot.name === this.operation.type && ot.progressive)

        return found
      }

      return false
    },

    generators() {
      if (this.operation.implant && this.operation.implantCode) {
        return utils.getGenerators(this.operation.implant).filter(gen => gen.code.trim() === this.operation.implantCode)
      } else {
        return []
      }
    }
  },

  methods: {
    normalizeSubscriptionCity(value) {
      if (!value || typeof value !== 'string') {
        return ''
      }

      return value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .toUpperCase()
    },

    checkRequired() {
      if (!this.operation.client) {
        alert('Proprietario obbligatorio!')
        return false
      }
      if (!this.operation.place) {
        alert('Luogo obbligatorio!')
        return false
      }
      if (!this.operation.implant) {
        alert('Impianto obbligatorio!')
        return false
      }
      if (!this.operation.occupant) {
        alert('Occupante obbligatorio!')
        return false
      }
      if (!this.operation.operators?.length) {
        alert('Collaboratore obbligatorio!')
        return false
      }

      return true
    },

    checkProgressive() {
      if (!this.isProgressive) {
        this.operation.progressive = null
      }
    },

    saveOperation() {
      if (!this.checkRequired()) {
        return false
      }

      const self = this
      this.disabledSave = true

      this.checkProgressive()

      this.$http.post('/operation', this.operation)
      .then(function (response) {
        self.$emit('updateToClose')

        utils.deleteDraft(self, self.operation._timestamp, 'operation').then(() => {
          const createdId = response?.data?._id
          if (createdId) {
            self.$router.replace('/appuntamenti/' + createdId)
          } else {
            self.$router.push('/appuntamenti')
          }
        })
      })
      .catch(function (error) {
        console.log(error)
        alert(error?.response?.data?.message || 'Errore')
        self.disabledSave = false
      })
    },

    updateOperation() {
      if (!this.checkRequired()) {
        return false
      }
      
      const self = this
      this.disabledSave = true

      this.checkProgressive()

      let revisions = []
      if (this.operation.implant && this.operation.implant.revisions && this.operation.implant.revisions.length > 0) {
        revisions = this.operation.implant.revisions
      }

      this.$http.put('/operation/' + this.operation._id, {...this.operation, revisions})
      .then(function (response) {
        self.checkToComplete().then(() => {
          self.$emit('updateToClose')
          utils.deleteDraft(self, self.operation._timestamp, 'operation').then(() => {
            self.disabledSave = false
          })
        })
      })
      .catch(function (error) {
        console.log(error)
        alert(error?.response?.data?.message || 'Errore')
        self.disabledSave = false
      })
    },

    async checkToComplete() {
      // Create linked call when status is set to "Da completare"
      if (this.operation.status === 'Da completare' && (this.originalOperation.status !== this.operation.status)) {
        const callData = {
          client: this.operation.client._id,
          occupant: this.operation.occupant._id,
          place: this.operation.place._id,
          implant: this.operation.implant._id,
          date: this.operation.appointment_date,
          operator: this.operation?.operators[0],
          type: this.operation.type,
          notes: this.operation.notes
        }

        callData.archived_notes = this.operation.archived_notes ? cloneDeep(this.operation.archived_notes) : []
        callData.archived_notes.push({
          date: new Date().toDateInputValue(),
          notes_office: this.operation.notes_office,
          notes: this.operation.notes,
          operation: this.operation._id
        })

        try {
          await this.$http.post('/call', callData)

          //archivia eventuale chiamata originale collegata all'appuntamento
          if (this.operation.call) {
            await this.$http.put('/call/' + this.operation.call, {archived: true})
          }
        } catch (error) {
          console.error('Error creating linked call:', error)
          alert('Errore durante la creazione della nuova chiamata')
        }
      }
    },

    getPlaces(force = true) {
      const self = this
      self.waitPlaces = true

      const client = this.operation.client ? this.operation.client._id : null
      const occupant = this.operation.occupant ? this.operation.occupant._id : null

      let query = ''
      if (client) {
        query = '/place/client-from-implant/' + client
      } else if (occupant) {
        query = '/place/occupant-from-implant/' + occupant
      } else {
        self.places = []
        self.operation.place = null
        self.changePlace(null)
        return true
      }

      this.$http.get(query)
      .then(function (response) {
        if (response && response.data) {
          self.places = response.data

          if (force && self.places.length === 1) {
            self.operation.place = self.places[0]
            self.changePlace(self.operation.place)
          }
        }
        self.waitPlaces = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    },

    getImplants(place, force = true) {
      const self = this
      self.waitImplants = true

      this.$http.get('/implant', { params: {page: 1, size: -1, place_id: place._id} })
      .then(function (response) {
        if (response && response.data) {
          self.implants = response.data.records

          if (force && self.implants.length === 1) {
            self.operation.implant = self.implants[0]
            self.operation.revision = null
            self.changeImplant(self.implants[0])
          }
        }
        self.waitImplants = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    },

    changeClient() {
      this.operation.occupant = null
      this.operation.place = null
      this.operation.implant = null
      this.operation.no_due = false

      if (this.operation.client) {
        this.disableOccupant = true
        this.getPlaces()
      } else {
        this.disableOccupant = false
      }
    },

    changeOccupant() {
      this.operation.client = null
      this.operation.place = null
      this.operation.implant = null
      this.operation.no_due = false

      if (this.operation.occupant) {
        this.disableClient = true
        this.getPlaces()
      } else {
        this.disableClient = false
      }
    },

    changePlace(place) {
      this.operation.implant = null
      this.operation.no_due = false

      if (place) {
        this.getImplants(place)
      }
    },

    changeImplant(implant) {
      if (implant) {
        this.operation.client = implant.client
        this.operation.occupant = implant.occupant

        if (implant.codes?.length === 1) {
          this.operation.implantCode = implant.codes[0]
        }
        if (this.generators?.length) {
          this.operation.implantGenerators = this.generators
        }
      } else {
        this.operation.implantCode = null
        this.operation.implantGenerators = []
      }

      // Subscription is linked to the selected implant: recalculate no_due on implant change.
      this.operation.no_due = !!this.activeSubscription
    },

    changeImplantCode(code) {
      if (code) {
        if (this.generators?.length) {
          this.operation.implantGenerators = this.generators
        }
      } else {
        this.operation.implantGenerators = []
      }
    },

    goBack() {
      this.$store.commit('setForm', {name: 'operation', value: false})
      this.$router.back()
    },

    getMostRecent(dates) {
      if (Array.isArray(dates)) {
        return utils.getMostRecent(dates)
      } else {
        return false
      }
    },

    /*isExpired(date) {
      if (date) {
        return utils.isExpired(date.end)
      } else {
        return false
      }
    },*/

    findClientName(id) {
      const found = this.clients.find(client => client._id === id)

      if (found) {
        return this.$clientName(found)
      } else {
        return ''
      }
    },

    checkStatus() {
      if (!this.operation.type) {
        alert('Tipologia non selezionata!')
        return false
      }
      if (this.isMaintenance && (!this.operation.implant.revisions || this.operation.implant.revisions.length === 0)) {
        alert('Hai selezionato una manutenzione ma l\'impianto non ha nessuna manutenzione!')
        return false
      }
      if (this.isMaintenance && !this.operation.revision) {
        alert('Manutenzione non selezionata!')
        return false
      }

      if (this.isRequiredNotes && (!this.operation.notes || this.operation.notes.trim().length === 0)) {
        alert('Devi inserire le Note tecnico!')
        return false
      }

      const requiresFiscalSelection = !this.operation.special2 && !this.operation.no_due
      if (requiresFiscalSelection && !this.operation.receipt && !this.operation.to_invoice) {
        alert('Prima di concludere devi selezionare Scontrino o Da fatturare, oppure attivare il flag rosso o Non deve nulla!')
        return false
      }

      if (this.operation.paid === true && !this.operation.payment_method) {
        alert('Per i privati devi indicare il metodo di pagamento!')
        return false
      }

      return true
    },

    startCloseAppointment() {
      const self = this

      if (self.checkStatus()) {
        if (this.isMaintenance) {
          self.$refs.revisions.openModalRevisionLog(0)
        } else {
          self.endCloseAppointment()
        }
      }
    },

    endCloseAppointment() {
      const self = this

      this.operation.status = 'Concluso'

      self.updateOperation()
    },

    getProgressive() {
      const self = this

      this.$http.get('/operation/progressive', {params: {date: self.operation.appointment_date}})
      .then(function (response) {
        if (response) {
          self.operation.progressive = response?.data
        }
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    },

    preselectRevision() {
      if (this.isMaintenance && this.operation.implant.revisions?.length === 1) {
        this.operation.revision = this.operation.implant.revisions[0]
      } else {
        this.operation.revision = null
      }
    },

    getInstallers() {
      let label = utils.getInstallers(this.operation.implantGenerators)

      if (label) {
        return 'Installatore: ' + label
      } else {
        return null
      }
    },

    findOrder() {
      const self = this

      this.$http.get('/order', { params: {
        product: this.addProductSelected?._id
      } }).then(response => {
        if (response && response.data) {
          self.orders = response.data.records
          
          self.openModalSelectOrder = true
        }
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    },

    selectedProduct(value) {
      this.addProductSelected = value
      
    },

    addOrder() {
      const self = this

      let editedProduct = {}

      self.selectedOrder.products.forEach(product => {
        if (product.product === self.addProductSelected._id) {
          const saleVat = self.normalizeVat(product.vat)
          product.linked.push({
            operation: self.operation._id,
            quantity: 1,
            vat: saleVat
          })
          editedProduct = product

          self.operation.linked.push({
            order: self.selectedOrder._id,
            product: editedProduct,
            quantity: 1,
            vat: saleVat
          })
        }
      })

      this.$http.put('/order/' + this.selectedOrder._id, {...this.selectedOrder})
      .then(function (response) {
        self.checkToComplete().then(() => {
          self.openModalSelectOrder = false
          self.openModalAddProduct = false
        })
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    },

    createNewCall() {
      const self = this
      this.creatingCall = true

      const baseNote = `Chiamata creata da appuntamento del ${new Date(this.operation.appointment_date).toDisplay()}`
      const technicianNote = (this.operation.notes || '').trim()

      const callData = {
        client: this.operation.client?._id,
        occupant: this.operation.occupant?._id,
        place: this.operation.place?._id,
        implant: this.operation.implant?._id,
        date: new Date().toDateInputValue(),
        time: new Date().toDateTimeInput(),
        operator: this.operation.operators?.[0]?._id,
        type: this.operation.type,
        notes: technicianNote ? `${baseNote}\n\nNote tecnico:\n${technicianNote}` : baseNote
      }

      this.$http.post('/call', callData)
      .then(function (response) {
        self.creatingCall = false
        self.$router.push('/chiamate/' + response.data._id)
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore durante la creazione della chiamata')
        self.creatingCall = false
      })
    },

    async openEditPriceModal(link) {
      this.editPriceLink = link
      this.editPriceValue = link.customPrice || link.product.lastSalePrice || link.product.price || ''
      this.editPriceModal = true

      if (!link.customPrice) {
        const productId = link?.product?.product
        if (productId) {
          try {
            const response = await this.$http.get('/product/' + productId + '/history')
            const history = response?.data || []
            if (history.length && history[0]?.price) {
              this.editPriceValue = history[0].price
            }
          } catch (error) {
            console.log(error)
          }
        }
      }
    },

    async saveCustomPrice() {
      const link = this.editPriceLink
      link.customPrice = this.editPriceValue
      this.editPriceModal = false

      if (link?.order) {
        try {
          const response = await this.$http.get('/order/' + link.order)
          if (response && response.data) {
            const order = response.data

            for (const product of order.products || []) {
              const linked = product.linked || []

              let target = null

              if (link.linkId) {
                target = linked.find(l => l._id?.toString() === link.linkId.toString())
              }

              if (!target && this.operation?._id) {
                target = linked.find(l => l.operation?._id?.toString() === this.operation._id.toString())
              }

              if (target) {
                target.customPrice = this.editPriceValue
                target.vat = this.normalizeVat(link.vat)
                break
              }
            }

            await this.$http.put('/order/' + link.order, order)
          }
        } catch (error) {
          console.log(error)
          alert('Errore')
        }
      }

      this.editPriceLink = null
      this.editPriceValue = ''
    },

    async activateSubscription() {
      //if (!this.operation || !this.operation._id) return
      if (!this.operation.implant || !this.operation.implant._id) {
        alert('Seleziona un impianto prima di attivare un abbonamento')
        return
      }

      if (!confirm('Attivare un abbonamento annuale per questo impianto?')) return

      this.activatingSubscription = true

      try {
        // call backend route that accepts implant id directly
        const res = await this.$http.post('/operation/implant/' + this.operation.implant._id + '/activate-subscription', { start: this.operation.appointment_date })

        // Keep local unsaved edits (notes, flags, etc.) and update only implant subscriptions in-place.
        if (!this.operation.implant) this.operation.implant = { subscriptions: [] }
        if (!this.operation.implant.subscriptions) this.operation.implant.subscriptions = []

        if (res && res.data) {
          const alreadyPresent = this.operation.implant.subscriptions.some(subscription => {
            if (subscription?.createdAt && res.data?.createdAt) {
              return subscription.createdAt === res.data.createdAt
            }

            return (
              subscription?.start === res.data?.start &&
              subscription?.end === res.data?.end &&
              (subscription?.note || '') === (res.data?.note || '')
            )
          })

          if (!alreadyPresent) {
            this.operation.implant.subscriptions.push(res.data)
          }
        }
      } catch (err) {
        console.error(err)
        alert(err?.response?.data?.message || 'Errore durante attivazione abbonamento')
      }

      this.activatingSubscription = false
    },

    findOperationSubscriptionIndex(targetSubscription) {
      if (!Array.isArray(this.operation?.implant?.subscriptions)) {
        return -1
      }

      const byReference = this.operation.implant.subscriptions.indexOf(targetSubscription)
      if (byReference !== -1) {
        return byReference
      }

      return this.operation.implant.subscriptions.findIndex(subscription => {
        if (targetSubscription?.createdAt && subscription?.createdAt) {
          return subscription.createdAt === targetSubscription.createdAt
        }

        return (
          subscription?.start === targetSubscription?.start &&
          subscription?.end === targetSubscription?.end &&
          (subscription?.note || '') === (targetSubscription?.note || '')
        )
      })
    },

    openSubscriptionEditModal(subscription) {
      if (!subscription) return

      this.selectedSubscription = subscription
      this.subscriptionEditForm.start = subscription.start || ''
      this.subscriptionEditForm.end = subscription.end || ''
      this.openModalSubscriptionEdit = true
    },

    async saveSubscriptionDatesFromOperation() {
      if (!this.operation?.implant?._id || !this.selectedSubscription) return

      if (!this.subscriptionEditForm.start || !this.subscriptionEditForm.end) {
        alert('Inserisci sia data inizio che data fine')
        return
      }

      const start = new Date(this.subscriptionEditForm.start)
      const end = new Date(this.subscriptionEditForm.end)
      if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
        alert('Date non valide')
        return
      }
      if (end < start) {
        alert('La data fine non puo essere precedente alla data inizio')
        return
      }

      const idx = this.findOperationSubscriptionIndex(this.selectedSubscription)
      if (idx === -1) return

      this.savingSubscriptionEdit = true

      this.operation.implant.subscriptions[idx].start = this.subscriptionEditForm.start
      this.operation.implant.subscriptions[idx].end = this.subscriptionEditForm.end

      try {
        await this.$http.put('/implant/' + this.operation.implant._id, { subscriptions: this.operation.implant.subscriptions })

        this.openModalSubscriptionEdit = false
        this.selectedSubscription = null
      } catch (err) {
        console.error(err)
        alert('Errore aggiornamento abbonamento')
      }

      this.savingSubscriptionEdit = false
    },

    

    calcLinkTotal(link) {
      const rawPrice = (link.customPrice || link.product.lastSalePrice || link.product.price || 0).toString().replaceAll('€', '').trim()
      const price = parseFloat(rawPrice || 0)
      const quantity = parseFloat(link.quantity || 1)
      const vatMultiplier = this.getVatMultiplier(link.vat)
      return (price * quantity * vatMultiplier).toFixed(2)
    },

    normalizeVat(vat) {
      const parsedVat = parseFloat(vat)
      if (parsedVat === 10 || parsedVat === 22) {
        return String(parsedVat)
      }
      return '22'
    },

    getVatMultiplier(vat) {
      const normalizedVat = parseFloat(this.normalizeVat(vat))
      return 1 + (normalizedVat / 100)
    },

    calcEditedLinkTotalIvato() {
      const price = parseFloat(this.editPriceValue || 0)
      const quantity = parseFloat(this.editPriceLink?.quantity || 1)
      const vatMultiplier = this.getVatMultiplier(this.editPriceLink?.vat)
      if (isNaN(price) || isNaN(quantity)) {
        return '0.00'
      }
      return (price * quantity * vatMultiplier).toFixed(2)
    },

    normalizeOperationLinkedVat() {
      if (!Array.isArray(this.operation?.linked)) {
        return
      }

      this.operation.linked.forEach(link => {
        link.vat = this.normalizeVat(link?.vat ?? link?.product?.vat)
      })
    }
  },

  watch: {
    operation: {
      handler(value) {
        utils.prepareDraft(this, this.operation, value, 'operation')
      },
      deep: true
    }
  },

  mounted() {
    const self = this

    const id = this.$route.params.id

    if (id) {
      this.$http.get('/operation/' + id)
      .then(function (response) {
        self.originalOperation = cloneDeep(response.data)
        self.operation = response.data
        self.normalizeOperationLinkedVat()

        if (self.operation.client) {
          self.getPlaces(false)
        }
        if (self.operation.place) {
          self.getImplants(self.operation.place, false)
        }
        if (self.operation.client) {
          if (self.operation.client.business_name) {
            self.init.name = self.operation.client.business_name
          } else {
            self.init.name = self.$fullname(self.operation.client)
          }
        }
        if (self.operation.place) {
          self.init.subname = self.operation.place.city
        }
        if (self.operation.revision && self.operation.implant) {
          const found = self.operation.implant.revisions.find(rev => rev._id === self.operation.revision)

          if (found) {
            self.operation.revision = found
          }
        }

        self.waitRecord = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    } else {
      self.waitRecord = false

      if (this.$store.getters.getForm('operation')) {
        self.operation = this.$store.getters.getForm('operation')
        self.normalizeOperationLinkedVat()
      }
    }

    this.$http.get('/client/filter')
      .then(function (response) {
        if (response && response.data) {
          self.clients = response.data
        }
        self.waitClients = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
  }
}
</script>